<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="show" persistent max-width="600px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card>
        <v-card-title>
          <h2>Update Payment Info</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="resetAndClose"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-container grid-list-md>
            <v-layout wrap>

              <v-form
                  ref="addCcForm"
                  v-model="addCcData.addCcFormValid"
                  lazy-validation
              >
                <!-- this hidden element is just to take focus for the validation (so it doesn't fire early)-->
                <v-text-field class="d-none"></v-text-field>

                <v-flex xs12>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="addCcData.name" label="Name on card" required></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field :rules="genericRequiredFieldRule" mask="credit-card" v-model="addCcData.cardNumber" label="Card Number" required></v-text-field>
                </v-flex>

                <v-layout row wrap xs12>

                  <v-flex xs5 md4>
                    <v-text-field :rules="genericRequiredFieldRule" mask="####" v-model="addCcData.securityCode" label="Security Code" type="text" required></v-text-field>
                  </v-flex>

                  <v-flex xs1></v-flex>
                  <v-flex xs6 md4>
                    <v-text-field :rules="genericRequiredFieldRule" v-model="addCcData.zip" label="Billing Zip" type="text" required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-flex xs12 >

                  <v-layout row class="pt-2">
                    <v-label>Expiration</v-label>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs6 md3>
                      <v-select
                          :rules="genericRequiredFieldRule"
                          v-model="addCcData.expMonth"
                          :items="ccExpirationMonths"
                          label="Month"
                          required
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-select
                          :rules="genericRequiredFieldRule"
                          v-model="addCcData.expYear"
                          :items="ccExpirationYears"
                          label="Year"
                          required
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-form>
            </v-layout>



          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="resetAndClose">Cancel</v-btn>
          <v-btn color="primary" flat @click="submitCreditCardUpdate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import LoadingDialog from "../../LoadingDialog"
  import api from "../../../services/api_endpoints"

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      addCcData: {
        name: '',
        cardNumber: '',
        securityCode: '',
        zip: '',
        expMonth: '',
        expYear: '',
        addCcFormValid: false,
        showDialog: false,
      },
      ccExpirationMonths: Array.from(Array(12).keys()).map(x => 1 + x),
      ccExpirationYears: Array.from(Array(50).keys()).map(x => 2019 + x),
      genericRequiredFieldRule: [
        v => !!v || 'This field is Required'
      ],
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Credit card updated successfully"
      },
    }),
    props: {
      value: Boolean
    },
    methods: {
      resetAndClose() {
        this.$refs.addCcForm.reset()
        this.show = false
      },
      async submitCreditCardUpdate() {
        if (!this.$refs.addCcForm.validate()) return

        this.showLoadingDialog = true
        let response = await api.submitCcChange({
          cc_cvc: `${this.addCcData.securityCode}`,
          cc_exp_month: `${this.addCcData.expMonth < 10 ? '0' : ''}${this.addCcData.expMonth}`,
          cc_exp_year: `${this.addCcData.expYear}`,
          cc_number: `${this.addCcData.cardNumber}`
        })
        this.showLoadingDialog = false

        // console.log(`response.success ${response.success}`)
        if (response.success) {
          this.snackbar.success = true
          this.show = false
        } else {
          this.snackbar.error = true
        }

      },
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
